/* eslint-disable react/jsx-key */
import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    firstTitle: {
        fontSize: 16,
        fontWeight: 700,
        marginLeft: '2%',
    },
    firstInstructions: {
        fontSize: 14,
        marginLeft: '2%',
    },
    listContainer: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 30,
        marginTop: '1%',
        marginBottom: '1%',
        marginRight: '5%'
    },
    listItem: {
        display: 'flex', paddingBottom: 5, flexDirection: 'row', justifyContent: 'space-between'
    }
}));

const StaticDisplayMerit = () => {
    const classes = useStyles();

    const Data = [
        {
            title: "Entrants with A Level Qualification",
            Arr: [
                { key: "Students achieving 4 A grades at GCE ‘A’ Level:", value: "75% of Tuition Fee" },
                { key: "Students achieving 3 A (or 2 A and 2 B) grades at GCE ‘A’ Level:", value: "50% of Tuition Fee" },
                { key: "Students achieving 2 A (or 1 A & 2 B or 4 B) grades at GCE ‘A’ Level:", value: "75% of Tuition Fee" }
            ]
        },
        {
            title: "Entrants with BA/BSc/B.Com Qualification",
            Arr: [
                { key: "Aggregate marks 90% or above at Bachelor Level:", value: "75% of Tuition Fee" },
                { key: "Aggregate marks 80%  - 89% at Bachelor Level:", value: "50% of Tuition Fee" },
                { key: "Aggregate marks 70% - 79% at Bachelor Level:", value: "15% of Tuition Fee" }
            ]
        }
    ]

    const Data2 = [
        {
            title: "Entrants with High School Diploma& APs",
            Arr: [
                { key: "Students achieving A and A+ & Band 5 in two full APs", value: "75% of Tuition Fee" },
                { key: "Students achieving A- and B+ and Band 5 and Band 4 in the two APs", value: "50% of Tuition Fee" },
                { key: "Students achieving B- and B and Band 4 in the two APs", value: "15% of Tuition Fee" }
            ]
        },
        {
            title: "Entrants with IFP",
            Arr: [
                { key: "Students achieving 4 distinctions", value: "100% of Tuition Fee" },
                { key: "Students achieving 3 distinctions ", value: "70% of Tuition Fee" },
                { key: "Students achieving 2 distinctions", value: "30% of Tuition Fee" },
                { key: "Students achieving 1 distinction and 1 merit", value: "15% of Tuition Fee" },
                { key: "(one distinction considered equivalent to two merits (60-69 mark range))", value: "" },
            ]
        }
    ]

    const Data3 = [
        {
            title: "Entrants with ‘O’ Level Qualification",
            Arr: [
                { key: "Students achieving 7 or more A grades at ‘O’ Level ", value: "50% of Tuition Fee" },
                { key: "Students achieving 6 A grades", value: "40% of Tuition Fee" },
                { key: "Students achieving 5 A grades", value: "20% of Tuition Fee" }
            ]
        },
        {
            title: "Entrants with Intermediate Level Qualification",
            Arr: [
                { key: "Aggregate marks 80% or above at Intermediate Level:", value: "30% of Tuition Fee" },
                { key: "Aggregate marks 70% - 79% at Intermediate Level:", value: "15% of Tuition Fee" }
            ]
        },
        {
            title: "Entrants with High School Diploma",
            Arr: [
                { key: "Students achieving A and A+", value: "40% of Tuition Fee" },
                { key: "Students achieving A- and B+", value: "20% of Tuition Fee" }
            ]
        }
    ]

    const Data4 = [
        {
            title: "For EMFSS:",
            Arr: [
                { key: "Students achieving 4 distinctions", value: "100% of Tuition Fee" },
                { key: "Students achieving 3 distinctions ", value: "70% of Tuition Fee" },
                { key: "Students achieving 2 distinctions", value: "30% of Tuition Fee" },
                { key: "Students achieving 1 distinction and 1 merit", value: "15% of Tuition Fee" },
            ]
        },
        {
            title: "For BBA:",
            Arr: [
                { key: "Students achieving 4 distinctions", value: "100% of Tuition Fee" },
                { key: "Students achieving 3 distinctions ", value: "50% of Tuition Fee" },
                { key: "Students achieving 2 distinctions", value: "20% of Tuition Fee" },
                { key: "Students achieving 1 distinction and 1 merit", value: "10% of Tuition Fee" },
            ]
        },
    ]

    return (
        <Fragment>
            <div style={{
                paddingBottom: 10, paddingTop: 20, width: '90%',
                marginLeft: '4%'
            }}>
                    <span className={classes.firstTitle}>First Year</span>
                    <hr />
                    <span className={classes.firstInstructions}>Academic</span>
                    <br />

                    <div style={{ marginTop: 20 }}>
                        <span className={classes.firstTitle}>BSc and BBA Programs</span>
                    </div>
                    {Data.map(item => {
                        return (
                            <Fragment>
                                <div style={{ marginTop: 20, marginLeft: 10 }}>
                                    <span style={{ textDecoration: 'underline' }} className={classes.firstTitle}>{item.title}</span>
                                </div>
                                <div className={classes.listContainer}>
                                    {item.Arr.map(list => {
                                        return (
                                            <div className={classes.listItem}>
                                                <span>
                                                    {list.key}
                                                </span>
                                                <span>
                                                    {list.value}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Fragment>
                        );
                    })}
                    <div style={{
                        marginLeft: '5%',
                        marginTop: '2%',
                        marginBottom: '2%'
                    }}>The above scheme applies if applicants have ‘A’ Level or hold a Bachelor’s degree.</div>
                    {Data2.map(item => {
                        return (
                            <Fragment>
                                <div style={{ marginTop: 20, marginLeft: 10 }}>
                                    <span style={{ textDecoration: 'underline' }} className={classes.firstTitle}>{item.title}</span>
                                </div>
                                <div className={classes.listContainer}>
                                    {item.Arr.map(list => {
                                        return (
                                            <div className={classes.listItem}>
                                                <span>
                                                    {list.key}
                                                </span>
                                                <span>
                                                    {list.value}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Fragment>
                        );
                    })}
                    <div style={{ marginTop: 20 }}>
                        <span className={classes.firstTitle}>CertHE in Social Sciences (CHESS)</span>
                    </div>
                    {Data3.map(item => {
                        return (
                            <Fragment>
                                <div style={{ marginTop: 20, marginLeft: 10 }}>
                                    <span style={{ textDecoration: 'underline' }} className={classes.firstTitle}>{item.title}</span>
                                </div>
                                <div className={classes.listContainer}>
                                    {item.Arr.map(list => {
                                        return (
                                            <div className={classes.listItem}>
                                                <span>
                                                    {list.key}
                                                </span>
                                                <span>
                                                    {list.value}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Fragment>
                        );
                    })}
                    <div style={{
                        marginLeft: '5%',
                        marginTop: '2%',
                        marginBottom: '2%'
                    }}><strong>NOTE : </strong>For qualifications not listed above, an equivalence certificate from the HEC/Relevant Examining Board will be required to determine the scholarship.</div>
                    <div style={{
                        marginLeft: '5%',
                        marginTop: '2%',
                        marginBottom: '2%'
                    }}><div style={{ marginBottom: '-5px' }}><strong>Sports</strong></div> <br />For qualifications not listed above, an equivalence certificate from the HEC/Relevant Examining Board will be required to determine the scholarship.</div>
                    <span className={classes.firstTitle}>Subsequent Years</span>
                    <hr />
                    <span className={classes.firstInstructions}>
                        The scholarship in the subsequent years is awarded on the basis of the marks attained in the University of London examinations in each year.
                        </span>
                    <br />
                    {Data4.map(item => {
                        return (
                            <Fragment>
                                <div style={{ marginTop: 20, marginLeft: 10 }}>
                                    <span style={{ textDecoration: 'underline' }} className={classes.firstTitle}>{item.title}</span>
                                </div>
                                <div className={classes.listContainer}>
                                    {item.Arr.map(list => {
                                        return (
                                            <div className={classes.listItem}>
                                                <span>
                                                    {list.key}
                                                </span>
                                                <span>
                                                    {list.value}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Fragment>
                        );
                    })}
                    <div style={{
                        marginLeft: '5%',
                        marginTop: '2%',
                        marginBottom: '2%'
                    }}><div style={{ marginBottom: '-5px' }}>
                            <strong>Sports: </strong></div>
                        <br />Sports scholarship will continue provided the following criteria are met: <br />
                        <div style={{
                            marginTop: '15px',
                            marginBottom: '-10px'
                        }}><strong>a)</strong> Satisfactory report from the Sports Head</div> <br />
                        <div><strong>b)</strong> Passing all subjects in the preceding year </div></div>

                    <span className={classes.firstTitle}>Other Rules</span>
                    <hr />
                    <span className={classes.firstInstructions}>
                        Scholarships will be paid in the current academic year on the basis of the UoL results in the previous academic year subject to the following conditions:
                        </span>
                    <div style={{
                        marginLeft: '5%',
                        marginTop: '2%',
                        marginBottom: '2%'
                    }}>
                        <div style={{
                            marginTop: '15px',
                            marginBottom: '-10px'
                        }}><strong>a)</strong> The scholarship will be paid in two equal installments. The first installment will be paid in January subject to achieving at least 50% credit points in the December Report.
                         The second installment will be paid in April subject to achieving at least 50% credit points in the April Report.</div> <br />
                        <div><strong>b)</strong>  The scholarship is paid on a pro rata basis if the number of subjects taken at UCL is less than four full units. </div><br />
                        <div><strong>c)</strong>  The scholarship cannot be availed by students who have received fee concession on any other ground.</div><br />
                        <div><strong>d)</strong>  All dues, including tuition fees, are paid up-to-date.</div><br />
                    </div>
            </div>
        </Fragment >
    );
}

export default StaticDisplayMerit;